import React from 'react'
import classnames from 'classnames'

const InlineTextInput = ({ type, id, error, value, onChange, className, ...props }) => {
  const classes = classnames(
    {
      'text-input--invalid': !!error,
    },
    "text-input",
    className
  );

  return (
    <input
      id={id}
      className={classes}
      type={type}
      value={value}
      onChange={onChange}
      {...props}
    />
  );
};

export default InlineTextInput
